import { select, selectAll, on } from 'helpers/dom'
import { setCookie, getCookie } from '@convertdigital/gamma-cookie'

const selectors = {
  MODAL_DIALOG_SELECTOR: 'modal-dialog',
  POPUP_FORM_SELECTOR: '.js-geolocation-popup-form',
  POPUP_BUTTON_SELECTOR: '.js-geolocation-popup-button',
  COUNTRY_CODE_SELECTOR: '.js-country-code',
  GEOLOCATION_COOKIE: 'geolocationCookie',
  TIMEOUT: 3000,
  COOKIE_DAY_EXPIRED: 60 * 60 * 24 * 10
}

class GeolocationPopup extends HTMLElement {
  constructor() {
    super()

    this.modal = select(selectors.MODAL_DIALOG_SELECTOR, this)
    this.form = select(selectors.POPUP_FORM_SELECTOR, this)
    this.buttons = selectAll(selectors.POPUP_BUTTON_SELECTOR, this)
    this.countryCodeField = select(selectors.COUNTRY_CODE_SELECTOR, this)
  }

  connectedCallback() {
    if (!this.modal || !window.Shopify) return

    if (!getCookie(selectors.GEOLOCATION_COOKIE) && !this.isCrawler()) {
      this.detectOptimalLocation()
    }

    if (this.form && this.countryCodeField && this.buttons.length) {
      this.buttons.forEach(button => {
        on('click', this.onButtonClick.bind(this, button), button)
      })
    }
  }

  isCrawler() {
    return /bot|crawl|spider|slurp|mediapartners|bingpreview|facebookexternalhit|screaming.frog/i.test(
      navigator.userAgent
    )
  }

  async detectOptimalLocation() {
    try {
      const currentStoreCountry = GM_STATE.shopify.storeCountry

      // Get browsing context suggestions from Shopify
      const suggestions = await this.getBrowsingContextSuggestions()

      if (!suggestions?.detected_values) {
        return
      }

      const detectedCountry = suggestions.detected_values.country.handle.toUpperCase()
      const isValid =
        (currentStoreCountry !== detectedCountry && currentStoreCountry === 'AU') ||
        (currentStoreCountry === 'NZ' && detectedCountry === 'AU')

      const urlParams = new URLSearchParams(window.location.search)
      const isAutoRedirect = urlParams.get('redirect') === 'auto'

      if (isAutoRedirect && isValid) {
        this.form.submit()

        return
      }

      if (isValid && !getCookie(selectors.GEOLOCATION_COOKIE)) {
        this.openModal()
        this.setCookieGeolocation()
      }
    } catch (error) {
      console.warn('Geolocation detection failed:', error)
    }
  }

  async getBrowsingContextSuggestions() {
    const params = new URLSearchParams({
      'country[enabled]': 'true',
      'country[exclude]': window.Shopify.country || '',
      'language[enabled]': 'false'
    })

    const response = await fetch(
      `${window.Shopify?.routes?.root}browsing_context_suggestions.json?${params}`
    )

    if (!response.ok) {
      console.error(`${response.status}: ${response.statusText}`)
    }

    return response.json()
  }

  openModal() {
    setTimeout(() => {
      this.modal.show()
    }, selectors.TIMEOUT)
  }

  setCookieGeolocation() {
    setCookie(selectors.GEOLOCATION_COOKIE, 1, selectors.COOKIE_DAY_EXPIRED)
  }

  onButtonClick(button) {
    this.countryCodeField.value = button.dataset.value
    this.form.submit()
  }
}

if (!customElements.get('geolocation-popup')) {
  customElements.define('geolocation-popup', GeolocationPopup)
}
